export default __webpack_public_path__ + "static/media/ic-gettrained.f35ff05a.svg";